import React from "react";

// const LayOut = React.lazy(() => import("@components/pages/auth/LayOut"));
const LayOut = React.lazy(() => import("../components/pages/auth/LayOut"));
const Login = React.lazy(() => import("../components/pages/auth/Login/Login"));
const ProtectedLayout = React.lazy(() => import("../components/pages/ProtectedLayout"));
const Home = React.lazy(() => import("../components/pages/dashboard/Home"));
const PageNotFound = React.lazy(() => import("../components/protected/PageNotFound"));
const LoadComponent = React.lazy(() => import("../components/pages/layout/ComingSoon"));
const ViewSiteConfig = React.lazy(() => import("../components/pages/SiteConfiguration/ViewSiteConfig/ViewSiteConfig"));
//Vault Access
const VaultDashboard = React.lazy(() => import("../components/pages/VaultInsights/VaultInsights"));
const AlartsAlarms = React.lazy(() => import("../components/pages/AlartsAlarms/AlartsAlarms"));
const UserManagement = React.lazy(() => import("../components/pages/UserManagement"));
// const VaultInsights = React.lazy(() => import("../components/pages/VaultInsights/VaultInsights"));
const SiteConfiguration = React.lazy(() => import("../components/pages/SiteConfiguration/SiteConfiguration"));
const UserProfile = React.lazy(() => import("../components/pages/SiteConfiguration/Unknown/UserInfo"));
const EditUserInfo = React.lazy(() => import("../components/pages/SiteConfiguration/Unknown/EditUserInfo"));
const VaultUserProfile = React.lazy(() => import('../components/pages/UserProfile/UserProfile'))
const ProfileRequests = React.lazy(() => import('../components/pages/ProfileRequests/ProfileRequests'))
//FRS
const PresenceDashboard = React.lazy(() => import("../components/pages/PresenceDashboard/PresenceDashboard"));
const FRSDashboard = React.lazy(() => import("../components/pages/dashboard/FRSDashboard"));
const EmployeeInsights = React.lazy(() => import("../components/pages/EmployeeInsights/EmployeeInsights"));
const VisitorInsights = React.lazy(() => import("../components/pages/VisitorInsights/VisitorInsights"));
const Registered = React.lazy(() => import("../components/pages/Registrations/Registrations"));
const VisitorAcknowledgements = React.lazy(() => import("../components/pages/VisitorAcknowledgements/VisitorAcknowledgements"));
const Insights = React.lazy(() => import("../components/pages/Insights"));
const PresenceDetails = React.lazy(() => import("../components/pages/PresenceDetails/PresenceDetails"));
const Registrations = React.lazy(() => import("../components/pages/EmpVisitorRegistrations/EmpVisitorRegistrations"));
//Banking Perspective
const bankingDashboard  = React.lazy(() => import("../components/pages/Banking/BankingDashboard/BankDashboard"));
const bankingInsights = React.lazy(() => import("../components/pages/Banking/BankingInsights/Insights"));
const bankingAlerts = React.lazy(()=>import("../components/pages/Banking/BankAlarms"));
const BankAnalytics = React.lazy(()=>import("../components/pages/Banking/BankAnalytics"));
const BankingFRS = React.lazy(()=>import("../components/pages/Banking/BankingFRS"));
const BankingHealth = React.lazy(()=>import("../components/pages/Banking/BankingHealth"));
//Retail Management
const RetailDashboard = React.lazy(() => import("../components/pages/dashboard/RetailDashboard/index"));
const Stores = React.lazy(() => import("../components/pages/Stores"));
const SmartPanel = React.lazy(() => import("../components/pages/SmartPanel"));
const RetailAlarms = React.lazy(() => import("../components/pages/RetailAlarms/index"));
const RetailMap = React.lazy(() => import("../components/pages/RetailMap/PANMap"));
const GuardPanic = React.lazy(() => import("../components/pages/GuardPanic/GuardPanic"));
const CameraConfig = React.lazy(() => import("../components/pages/CameraConfig/CameraConfig"));
//C-Portal
const Tickets = React.lazy(() => import("../components/pages/Tickets"));
const CportalDashboard = React.lazy(() => import("../components/pages/dashboard/CportalDashboard/CportalDashboard"));
const Reports = React.lazy(() => import("../components/pages/Reports"));
const Alarms = React.lazy(() => import("../components/pages/Alarms"));
const Health = React.lazy(() => import("../components/pages/Health"));
const Map = React.lazy(() => import("../components/pages/Map"));
const Archive = React.lazy(() => import("../components/pages/Archive"));
// const Archive = React.lazy(() => import("../components/pages/ArchiveContext"));
const LiveView = React.lazy(() => import("../components/pages/LiveView"));
// const LiveView = React.lazy(() => import("../components/pages/LiveViewContext"));
const ShutterAlarms = React.lazy(() => import("../components/pages/ShutterAlarms"));
const GuardAlarms = React.lazy(() => import("../components/pages/GuardAlarms"));
const ShutterActivity = React.lazy(() => import("../components/pages/ShutterActivity/ShutterActivity"));
const SmartSearch = React.lazy(() => import("../components/pages/SmartSearch"));
const CustomerReports = React.lazy(() => import("../components/pages/CustomerReports"));

//Lift
const LiftAnalyticsDashboard = React.lazy(() => import("../components/pages/LiftAnalyticsDashboard/LiftAnalyticsDashboard"));
const DeviceDownTime = React.lazy(() => import("../components/pages/DeviceDownTime/DeviceDownTime"));
const TemperatureTrend = React.lazy(() => import("../components/pages/Temperature/Temperaturetrends"));

//IRCTC
const IRCTCDashboard = React.lazy(() => import("../components/pages/IRCTC/dashboard/CportalDashboard/CportalDashboard"));
const IRCTCAlarms = React.lazy(() => import("../components/pages/IRCTC/Alarms"));
const IRCTCArchive = React.lazy(() => import("../components/pages/IRCTC/Archive"));
const IRCTCLiveView = React.lazy(() => import("../components/pages/IRCTC/LiveView"));
const IRCTCHealth = React.lazy(() => import("../components/pages/IRCTC/Health"));

export const RoutesConfig = [
    {
        protected: false,
        LayOut: LayOut,
        RoutesNames: [
            { path: "/auth/login", element: Login, },
            { path: "*", element: PageNotFound, },
        ],
    },
    {
        protected: true,
        LayOut: ProtectedLayout,
        RoutesNames: [
            { path: "/vaultDashboards", element: VaultDashboard },
            { path: "/cportalDashboard", element: CportalDashboard },
            { path: "/retailManagement", element: RetailDashboard },
            // { path: "/FRS", element: FRSDashboard },
            { path: "/tickets", element: Tickets },
            // { path: "/reports", element: Reports},
            { path: "/alarms", element: Alarms },
            { path: "/customer-reports", element: CustomerReports },
            { path: "/alerts-alarms", element: AlartsAlarms },
            { path: "/health", element: Health },
            { path: "/map", element: Map },
            { path: "/archive", element: Archive },
            { path: "/temperaturetrends", element: TemperatureTrend },
            { path: "/live-view", element: LiveView },
            { path: "/user-management", element: UserManagement },
            { path: "/employee-insights", element: EmployeeInsights},
            { path: "/visitor-insights", element: VisitorInsights },
            { path: "/insights", element: Insights },
            { path: "/presence-details", element: PresenceDetails },
            // { path: "/vault-insights", element: VaultInsights },
            { path: "/presencedashboard", element: PresenceDashboard },
            { path: "/banking-dashboard", element: bankingDashboard },
            { path: "/banking-insight", element: bankingInsights },
            { path: "/banking-frs", element: BankingFRS },
            { path: "/banking-alarm", element: bankingAlerts },
            { path: "/banking-analytic", element: BankAnalytics },
            // { path: "/banking-healthdashboard", element: BankingHealth },
            { path: "/retail-alarms", element: RetailAlarms },
            { path: "/retail-map", element: RetailMap },
            { path: "/guard-panic", element: GuardPanic },
            { path: "/camera-config", element: CameraConfig },
            { path: "/registrations", element: Registrations },
            { path: "/health/stores", element: Stores },
            { path: "/device-down-time", element: DeviceDownTime },
            { path: "/health/smart-panel", element: SmartPanel },
            { path: "/site-configuration", element: SiteConfiguration },
            { path: "/site-configuration/vault-user-profile", element: ViewSiteConfig },
            { path: "/site-configuration/user-profile", element: UserProfile },
            { path: "/site-configuration/edit-user-profile", element: EditUserInfo },
            { path: "/vaultUserProfile", element: VaultUserProfile },
            { path: "/visitor-acknowledgements", element: VisitorAcknowledgements },
            { path: "/profile-requests", element: ProfileRequests },
            { path: "/liftAnalytics", element: LiftAnalyticsDashboard },
            { path: "/shutterAlarms", element: ShutterAlarms },
            { path: "/guard-alarms", element: GuardAlarms },
            { path: "/shutter-activity", element: ShutterActivity },
            { path: "/smart-search", element: SmartSearch },
            { path: "/kitchen-dashboard", element: IRCTCDashboard },
            { path: "/kitchen-alarms", element: IRCTCAlarms },
            { path: "/kitchen-archive", element: IRCTCArchive },
            { path: "/kitchen-health", element: IRCTCHealth },
            { path: "/kitchen-live-view", element: IRCTCLiveView },
            { path: "/", element: LoadComponent },
        ]
    },
];
